import React, { useEffect } from 'react';
import { Modal, Form, Input, message } from 'antd';
import { useStoreUpdaterWithAPI } from '../../Hooks/UseStoreUpdaterWithApi';
import { APIConstants } from '../../Common/APIConstants';

const EmailPasswordReset = ({ visible, onClose }) => {
  const [form] = Form.useForm();
  const { makeRequest } = useStoreUpdaterWithAPI();

  useEffect(() => {
    form.resetFields();
  }, [visible]);

  const handleSubmit = async () => {
    try {
      const values = await form.validateFields();
      if (values.newPassword !== values.confirmPassword) {
        message.error('Passwords do not match');
        return;
      }

      const body = {
        emailID: values.email,
        newPassword: values.newPassword,
      };

      makeRequest({
        type: APIConstants.PUT,
        url: `${APIConstants.UPDATE_PASSWORD_API}`,
        body,
      }).then(() => {
        message.success('Password updated successfully!');
        onClose();
      });
    } catch (error) {
      // Validation failed
    }
  };

  return (
    <Modal
      title="Reset Password"
      open={visible}
      onCancel={onClose}
      onOk={handleSubmit}
      okText="Update Password"
    >
      <Form form={form} layout="vertical">
        <Form.Item
          name="email"
          label="Email Address"
          rules={[
            { required: true, message: 'Please enter your email' },
            { type: 'email', message: 'Enter a valid email' },
          ]}
        >
          <Input placeholder="you@example.com" />
        </Form.Item>

        <Form.Item
          name="newPassword"
          label="New Password"
          rules={[{ required: true, message: 'Please enter your new password' }]}
        >
          <Input.Password placeholder="New Password" />
        </Form.Item>

        <Form.Item
          name="confirmPassword"
          label="Confirm New Password"
          dependencies={['newPassword']}
          rules={[
            { required: true, message: 'Please confirm your new password' },
            ({ getFieldValue }) => ({
              validator(_, value) {
                if (!value || getFieldValue('newPassword') === value) {
                  return Promise.resolve();
                }
                return Promise.reject(new Error('Passwords do not match'));
              },
            }),
          ]}
        >
          <Input.Password placeholder="Confirm New Password" />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default EmailPasswordReset;


// import React, { useEffect } from 'react';
// import { Modal, Form, Input, message } from 'antd';
// import { useStoreUpdaterWithAPI } from '../../Hooks/UseStoreUpdaterWithApi';
// import { APIConstants } from '../../Common/APIConstants';

// const EmailPasswordReset = ({ visible, onClose }) => {
//   const [form] = Form.useForm();
//   const { makeRequest } = useStoreUpdaterWithAPI();

//   useEffect(() => {
//     form.resetFields();
//   }, [visible]);

//   const handleSubmit = async () => {
//     try {
//       const values = await form.validateFields();
//       if (values.newPassword !== values.confirmPassword) {
//         message.error('Passwords do not match');
//         return;
//       }

//       const body = {
//         emailID: values.email,
//         newPassword: values.newPassword,
//       };

//       makeRequest({
//         type: APIConstants.PUT,
//         url: `${APIConstants.UPDATE_PASSWORD_API}`,
//         body,
//       }).then(() => {
//         message.success('Password updated successfully!');
//         onClose();
//       });
//     } catch (error) {
//       // Validation failed
//     }
//   };

//   return (
//     <Modal
//       title="Reset Password"
//       open={visible}
//       onCancel={onClose}
//       onOk={handleSubmit}
//       okText="Update Password"
//  className="custom-transparent-modal"
//      >
//       <Form form={form} layout="vertical" >
//         <Form.Item
//           name="email"
//           label="Email Address"
//           rules={[
//             { required: true, message: 'Please enter your email' },
//             { type: 'email', message: 'Enter a valid email' },
//           ]}
//            className="login-input text-white  text-xl mb-9 font-bold"
//         >
//           <Input className="custom-login-input p-3  rounded-lg bg-transparent border border-gray-500  focus:bg-transparent focus:shadow-none !bg-transparent border-white border-2 w-full text-white font-bold text-lg hover:scale-105" placeholder="you@example.com" />
//         </Form.Item>

//         <Form.Item
//           name="newPassword"
//           label="New Password"
//           rules={[{ required: true, message: 'Please enter your new password' }]}
//         >
//           <Input.Password className="custom-login-input p-3  rounded-lg bg-transparent border border-gray-500  focus:bg-transparent focus:shadow-none !bg-transparent border-white border-2 w-full text-white font-bold text-lg hover:scale-105" placeholder="New Password" />
//         </Form.Item>

//         <Form.Item
//           name="confirmPassword"
//           label="Confirm New Password"
//           dependencies={['newPassword']}
//           rules={[
//             { required: true, message: 'Please confirm your new password' },
//             ({ getFieldValue }) => ({
//               validator(_, value) {
//                 if (!value || getFieldValue('newPassword') === value) {
//                   return Promise.resolve();
//                 }
//                 return Promise.reject(new Error('Passwords do not match'));
//               },
//             }),
//           ]}
//         >
//           <Input.Password className="custom-login-input p-3  rounded-lg bg-transparent border border-gray-500  focus:bg-transparent focus:shadow-none !bg-transparent border-white border-2 w-full text-white font-bold text-lg hover:scale-105" placeholder="Confirm New Password" />
//         </Form.Item>
//       </Form>
//     </Modal>
//   );
// };

// export default EmailPasswordReset;

// import React, { useState, useEffect } from 'react';
// import { Modal, Button, Form, Input, message } from 'antd';
// import { useStoreUpdaterWithAPI } from '../../Hooks/UseStoreUpdaterWithApi';
// import { APIConstants } from '../../Common/APIConstants';

// const EmailOtp = ({ visible, onClose }) => {
//   const [form] = Form.useForm();
//   const [showOtp, setShowOtp] = useState(false);
//   const [showPasswordFields, setShowPasswordFields] = useState(false);
//   const [loading, setLoading] = useState(false);
//   const { makeRequest } = useStoreUpdaterWithAPI();

//   useEffect(() => {
//     setShowOtp(false);
//     setShowPasswordFields(false);
//     form.resetFields();
//   }, [visible]);

//   const handleSendOtp = async () => {
//     try {
//       const values = await form.validateFields(['email']);
//       makeRequest({
//         type: APIConstants.POST,
//         url: `${APIConstants.UPDATE_USER_API}`,
//         body: values
//       }).then((res) => {
//         message.success(`OTP sent to ${values.email}`);
//       });
//       setLoading(true);
//       setTimeout(() => {
//         setLoading(false);
//         setShowOtp(true);
//       }, 1000);
//     } catch (error) {
//       // Validation failed
//     }
//   };

//   const handleVerifyOtp = async () => {
//     try {
//       const values = await form.validateFields(['email', 'otp']);
//       const body = {
//         emailID: values.email,
//         otp: values.otp
//       };
//       makeRequest({
//         type: APIConstants.POST,
//         url: `${APIConstants.CHECK_OTP_API}`,
//         body: body
//       }).then((res) => {
//         message.success('OTP Verified!');
//         console.log(res)
//         const resString = JSON.stringify(res).toLowerCase();
//       if (resString.includes('fail')) {
//         message.error('OTP Verification Failed');
//         setShowPasswordFields(false);
//       } else {
//         message.success('OTP Verified!');
//         setShowPasswordFields(true);
//       }
            
//       });
//     } catch (error) {
//       // Validation failed
//     }
//   };

//   const handleSubmitPassword = async () => {
//     try {
//       const values = await form.validateFields(['newPassword', 'confirmPassword','email']);
//       if (values.newPassword !== values.confirmPassword) {
//         message.error('Passwords do not match');
//         return;
//       }
//       console.log(values)
//       const body = {
//         ...values,
//         emailID: values.email,
//       };
//       console.log(body)
//       makeRequest({
//         type: APIConstants.PUT,
//         url: `${APIConstants.UPDATE_PASSWORD_API}`,
//         body: body
//       }).then((res) => {
//         message.success('Password updated successfully!');
//       });
//       onClose();
//     } catch (error) {
//       // Validation failed
//     }
//   };

//   return (
//     <Modal
//       title="Reset Password"
//       open={visible}
//       onCancel={onClose}
//       onOk={
//         showPasswordFields ? handleSubmitPassword : showOtp ? handleVerifyOtp : handleSendOtp
//       }
//       okText={showPasswordFields ? 'Update Password' : showOtp ? 'Verify OTP' : 'Send OTP'}
//       confirmLoading={loading}
//     >
//       <Form form={form} layout="vertical">
//         <Form.Item
//           name="email"
//           label="Email Address"
//           rules={[
//             { required: true, message: 'Please enter your email' },
//             { type: 'email', message: 'Enter a valid email' },
//           ]}
//         >
//           <Input placeholder="you@example.com" />
//         </Form.Item>

//         {showOtp && (
//           <Form.Item
//             name="otp"
//             label="Enter OTP"
//             rules={[{ required: true, message: 'Please enter the OTP' }]}
//           >
//             <Input.OTP length={4} inputType="numeric" />
//           </Form.Item>
//         )}

//         {showPasswordFields && (
//           <>
//             <Form.Item
//               name="newPassword"
//               label="New Password"
//               rules={[{ required: true, message: 'Please enter your new password' }]}
//             >
//               <Input.Password placeholder="New Password" />
//             </Form.Item>
//             <Form.Item
//               name="confirmPassword"
//               label="Confirm New Password"
//               dependencies={['newPassword']}
//               rules={[
//                 { required: true, message: 'Please confirm your new password' },
//                 ({ getFieldValue }) => ({
//                   validator(_, value) {
//                     if (!value || getFieldValue('newPassword') === value) {
//                       return Promise.resolve();
//                     }
//                     return Promise.reject(new Error('Passwords do not match'));
//                   },
//                 }),
//               ]}
//             >
//               <Input.Password placeholder="Confirm New Password" />
//             </Form.Item>
//           </>
//         )}
//       </Form>
//     </Modal>
//   );
// };

// export default EmailOtp;
